import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';

// @mui
import { CircularProgress, Container, Grid, Stack, Typography } from '@mui/material';

import { DownloadTreeAttachment, GetDirectoryList, PostCreateFolder } from 'src/components/services/httpServices';

import CustomizedTreeView from './MUITree';

export default function TreeView(props) {
  let { id, checkClient } = useParams();
  const navigate = useNavigate();
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('sdsdsdsds');
  const [data, setData] = useState(null);
  const [selectedNode, setSelectedNode] = useState(null);
  const [selectedPath, setSelectedPath] = useState(null);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const folderNameRef = useRef('');
  const fetchTreeData = async (event) => {
    const treeData = await GetDirectoryList(id, checkClient);
    console.log('treeData:', treeData);
    setData(treeData);
    setLoading(false);
  };
  useEffect(() => {
    const disableRightClick = (e) => {
      e.preventDefault();
    };

    // Add event listener when component mounts
    document.addEventListener('contextmenu', disableRightClick);

    // Remove event listener when component unmounts
    fetchTreeData();
    return () => {
      document.removeEventListener('contextmenu', disableRightClick);
    };
  }, [loading]);
  const SaveCompany = async (event) => {};

  const handleClose = () => {
    setOpen(false);
  };
  const getAttachment = async (node) => {
    setLoading(true);
    console.log('node?.type:', node?.type);
    if (node?.type == 'directory') {
      props.setMessage('Please Select File');
      props.setOpen(true);
    } else {
      var file = await DownloadTreeAttachment(id, checkClient, node?.name, node?.path);

      console.log('file', file);
      console.log('node', node);
      const url = window.URL.createObjectURL(new Blob([file.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', node?.name); //or any other extension
      document.body.appendChild(link);
      link.click();
      props.setMessage('Successfully Downloaded');
      props.setSaved(true);
      props.setOpen(true);
    }
    setLoading(false);
    setSelectedNode(null);
  };
  const createFolder = async () => {
    if (selectedPath != null && folderNameRef.current.value !== '') {
      setLoading(true);
      let payload = {
        code: folderNameRef?.current?.value,
        value: selectedPath,
      };
      console.log('payload:', payload);
      var response = await PostCreateFolder(payload);
      console.log('PostResponse:', response);
      if (response.status == 200) {
        props.setMessage(response.data);
        props.setSaved(true);
        props.setOpen(true);
        setLoading(false);
        folderNameRef.current.value = '';
        // setTimeout(() => {
        //   navigate(`/app/ClientTabs/${response.data.id}/${true}`);
        // }, 2000);
      } else {
        props.setMessage(response.data);
        props.setSaved(false);
        props.setOpen(true);
        setLoading(false);
        // setPosting(false);
      }
    } else {
      props.setMessage('Please select folder path and add Folder Name first!');
      props.setSaved(false);
      props.setOpen(true);
    }
  };
  //console.log('company', company);
  console.log('selectedNode', selectedNode);
  return (
    <>
      <Helmet>
        <title> Documents | Immigration System </title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {/* Saved Documents */}
          </Typography>

          {/* <Stack direction="row" spacing={2}>
            <TextField
              label="Folder Name"
              variant="outlined"
              fullWidth
              size="small"
              // defaultValue={company.companyName}
              inputRef={folderNameRef}
            />
            <Button variant="contained" onClick={createFolder}>
              Create
            </Button>
            {selectedNode !== null ? (
              <PdfViewerModal
                variant="contained"
                file={selectedNode?.name}
                treeView={false}
                selectedNode={selectedNode}
                title="View"
              />
            ) : (
              <Button disabled={!(selectedNode != null)} variant="contained">
                View
              </Button>
            )}
            <Button disabled={!(selectedNode != null)} onClick={() => getAttachment(selectedNode)} variant="contained">
              Download
            </Button>
          </Stack> */}
        </Stack>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <CustomizedTreeView
            setLoading={setLoading}
            setMessage={props.setMessage}
            setSaved={props.setSaved}
            setOpen={props.setOpen}
            setSelectedPath={setSelectedPath}
            setSelectedNode={setSelectedNode}
            selectedNode={selectedNode}
            data={data}
            getAttachment={getAttachment}
          />
        )}
      </Container>
    </>
  );
}
